export enum AccessType {
  INDIVIDUAL = "individual",
  TEAM = "team",
}
